import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=14d7b91b&scoped=true"
import script from "./Posts.vue?vue&type=script&lang=ts"
export * from "./Posts.vue?vue&type=script&lang=ts"
import style0 from "./Posts.vue?vue&type=style&index=0&id=14d7b91b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d7b91b",
  null
  
)

export default component.exports